import { FC } from 'react';

import './locations-tab.scss';

interface TimeZoneSelectProps {
  timeZone?: string;
  setTimeZone: (tz: string) => void;
}

const TimeZoneSelect: FC<TimeZoneSelectProps> = ({ timeZone, setTimeZone }) => {
  return (
    <div id="time-zone-select" className="text-field">
      <select
        className="w-100"
        id="location-time-zone"
        name="timeZone"
        value={timeZone ?? ''}
        onChange={e => setTimeZone(e.target.value)}
        required
        data-cy="time-zone-select"
      >
        <option value="" disabled />
        <option value="America/Aruba">AST - Atlantic Time (UTC-04:00)</option>
        <option value="America/New_York">ET - Eastern Time (UTC-05:00)</option>
        <option value="America/Chicago">CT - Central Time (UTC-06:00)</option>
        <option value="America/Denver">MT - Mountain Time (UTC-07:00)</option>
        <option value="America/Phoenix">MST - Arizona (UTC-07:00)</option>
        <option value="America/Los_Angeles">PT - Pacific Time (UTC-08:00)</option>
        <option value="America/Anchorage">AK - Alaska (UTC-09:00)</option>
        <option value="Pacific/Honolulu">HAST - Hawaii (UTC-10:00)</option>
        <option value="UTC">UTC - Coordinated Universal Time (UTC)</option>
      </select>
      <label htmlFor="location-time-zone">TIME ZONE *</label>
    </div>
  );
};

export default TimeZoneSelect;
